import { Users, Zap, Film, Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import { PublicNav } from "../components/PublicNav";

const statIcons = [Users, Film, Zap, Globe];

export default function About() {
  const { t } = useTranslation();
  const stats = t("about.stats", { returnObjects: true });
  const values = t("about.values.items", { returnObjects: true });

  return (
    <div className="min-h-screen" style={{ background: "#111111" }}>
      <PublicNav testIdPrefix="about" />

      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-20">
        <div className="mb-14">
          <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{ color: "#7c3aed" }}>{t("about.eyebrow")}</p>
          <h1 className="text-4xl sm:text-5xl font-black text-white mb-6" style={{ fontFamily: "Epilogue, sans-serif" }}>
            {t("about.titleLine1")}<br />
            <span style={{ color: "#c084fc" }}>{t("about.titleLine2")}</span>
          </h1>
          <p className="text-lg leading-relaxed" style={{ color: "#6b6b6b" }}>
            {t("about.intro")}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
          {stats.map(({ value, label }, i) => {
            const Icon = statIcons[i];
            return (
              <div key={label} className="rounded-2xl p-5 text-center"
                style={{ background: "#161616", border: "1px solid #252525" }}>
                <Icon className="w-4 h-4 mx-auto mb-2" style={{ color: "#7c3aed" }} />
                <p className="text-2xl font-black text-white">{value}</p>
                <p className="text-xs mt-0.5" style={{ color: "#6b6b6b" }}>{label}</p>
              </div>
            );
          })}
        </div>

        <div className="space-y-8" style={{ color: "#9a9a9a" }}>
          <div className="rounded-2xl p-7" style={{ background: "#161616", border: "1px solid #252525" }}>
            <h2 className="text-lg font-bold text-white mb-3">{t("about.mission.title")}</h2>
            <p className="text-sm leading-relaxed">{t("about.mission.body")}</p>
          </div>

          <div className="rounded-2xl p-7" style={{ background: "#161616", border: "1px solid #252525" }}>
            <h2 className="text-lg font-bold text-white mb-3">{t("about.how.title")}</h2>
            <p className="text-sm leading-relaxed">{t("about.how.body")}</p>
          </div>

          <div className="rounded-2xl p-7" style={{ background: "#161616", border: "1px solid #252525" }}>
            <h2 className="text-lg font-bold text-white mb-3">{t("about.values.title")}</h2>
            <ul className="space-y-2 text-sm">
              {values.map((v) => (
                <li key={v} className="flex items-start gap-2"><span style={{ color: "#7c3aed" }}>—</span> {v}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
